export const PATH = {
  DOWNLOADS: 'downloads',
  INFO: 'info',
}

export const dashboardLinks = {
  dashboardLink: () => '',
  dashboardDownloadLink: ({ id }: { id: string }) => `/${id}/${PATH.DOWNLOADS}`,
  dashboardInfoLink: ({ id }: { id: string }) => `/${id}/${PATH.INFO}`,
}
